import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid';
import React, { Component } from 'react';
import { addURL } from 'redux/actions/url';

class DaftarTugas extends Component {
    constructor(props) {
        super(props)

        this.dataGridRef = React.createRef()

        this.columns = [
            {
                dataField: 'id',
                caption: 'Decision ID'
            },
            {
                dataField: 'menuData',
                caption: 'Data Menu'
            },
            {
                dataField: 'keterangan',
                caption: 'Keterangan'
            },
            {
                dataField: 'inputBy',
                caption: 'Input Oleh'
            },
            {
                dataField: 'supervisor',
                caption: 'Supervisor'
            },
            {
                dataField: 'perubahanDate',
                caption: 'Tanggal Perubahan',
                dataType: 'date',
                format: 'dd MMM yyyy'
            },
            {
                dataField: 'tugas',
                caption: 'Tugas'
            },
            {
                dataField: 'Usertugas',
                caption: 'User Tugas'
            },
        ]
    }

    componentWillMount() {
        let store = this.props.store;
        store.dispatch(addURL(this.props.location.pathname))
    }

    loadDummyData = () => {
        const dummyData = [
            {
                id: 1,
                menuData: 'Menu Data 1',
                keterangan: 'Keterangan 1',
                inputBy: 'User 1',
                supervisor: 'Supervisor 1',
                perubahanDate: new Date('2023-01-01'),
                tugas: 'Tugas 1',
                userTugas: 'User Tugas 1'
            },
            {
                id: 2,
                menuData: 'Menu Data 2',
                keterangan: 'Keterangan 2',
                inputBy: 'User 2',
                supervisor: 'Supervisor 2',
                perubahanDate: new Date('2023-02-01'),
                tugas: 'Tugas 2',
                userTugas: 'User Tugas 2'
            },
            {
                id: 3,
                menuData: 'Menu Data 3',
                keterangan: 'Keterangan 3',
                inputBy: 'User 3',
                supervisor: 'Supervisor 3',
                perubahanDate: new Date('2023-03-01'),
                tugas: 'Tugas 3',
                userTugas: 'User Tugas 3'
            },
            {
                id: 4,
                menuData: 'Menu Data 4',
                keterangan: 'Keterangan 4',
                inputBy: 'User 4',
                supervisor: 'Supervisor 4',
                perubahanDate: new Date('2023-04-01'),
                tugas: 'Tugas 4',
                userTugas: 'User Tugas 4'
            },
            {
                id: 5,
                menuData: 'Menu Data 5',
                keterangan: 'Keterangan 5',
                inputBy: 'User 5',
                supervisor: 'Supervisor 5',
                perubahanDate: new Date('2023-05-01'),
                tugas: 'Tugas 5',
                userTugas: 'User Tugas 5'
            }
        ];

        return dummyData;
    }

    refreshDataGrid = () => {
        this.dataGridRef.current.forceRefresh()
    }

    forceRefresh = () => {
        this.dataGridRef.current.forceRefresh(true)
    }

    render() {
        return (
            <div className="container-fluid">
                <h2 className="main-title">Daftar Tugas</h2>
                <span>Berikut ini tugas Yang Belum di Lakukan</span>

                <DevExpressDataGrid
                    ref={this.dataGridRef}
                    loadAPI='-'
                    insertAPI='-'
                    updateAPI='-'
                    deleteAPI='-'

                    backendserver={process.env.REACT_APP_BACKEND_ACC}

                    useArraySource={true}
                    ArraySourceData={this.loadDummyData}

                    allowAdding={false}
                    allowDeleting={false}
                    allowUpdating={false}

                    exportExcel={false}
                    exportFileName={"Daftar-Tugas"}
                    allowExportSelectedData={true}
                    selection={"multiple"}

                    showBorders={true}

                    paging={true}
                    defaultPageSize={10}
                    height={'80vh'}

                    //bagian konfigurasi popup saat insert dan edit record
                    popupTitle={'Daftar-Tugas'}
                    popupWidth={700} //masukan dalam ukuran pixel
                    popupHeight={500} //masukkan dalam ukuran pixel

                    popupFormLabelLocation='left' //accepted value = top, left, right
                    popupFormMinColWidth={300} // minimum lebar kolom
                    popupFormColCount={3} //jumlah kolom pada form

                    //akhir bagian konfigurasi popup

                    ColumnChooser={true} // set false agar kolom tidak dapat di pindah pindah
                    ColumnFixing={true} // set false agar kolom tidak dapat di freeze

                    FilterRow={true} // set false untuk mematikan fitur filter

                    ColumnConfiguration={this.columns} // taruh konfigurasi kolom disini
                    SummaryConfiguration={this.summary}

                    onToolbarPreparing={this.onToolbarPreparing}

                    //contoh konfigurasi kolom
                    //this.columns = [{
                    //    dataField: 'kolom1',
                    //    caption: 'Ini Kolom 1'
                    //}, {
                    //    dataField: 'kolom2',
                    //    caption: 'Ini Kolom 2'
                    //}]
                    // detail konfigurasi dapat dilihat di https://js.devexpress.com/Documentation/ApiReference/UI_Widgets/dxDataGrid/Configuration/columns/

                    store={this.props.store} // jangan di edit edit
                />
            </div>
        )
    }
}

export default DaftarTugas
